<button class="btn btn-secondary"(click)="createSnapshotClick()">CREATE RECORD</button>
